import React from "react";
import * as Icons from "lucide-react";
import { Reveal } from "@/components/effects/Reveal";
import { VIDEO_SERVICES } from "@/lib/data";

const VIDEO_HERO =
  "https://images.unsplash.com/photo-1502139214982-d0ad755818d8?w=1600&q=85&auto=format&fit=crop";

export const VideoProduction = () => {
  return (
    <section data-testid="video-production-section" className="relative py-28 sm:py-36 overflow-hidden">
      <div className="absolute inset-0 -z-10">
        <img src={VIDEO_HERO} alt="" className="w-full h-full object-cover opacity-25" loading="lazy" />
        <div className="absolute inset-0" style={{ background: "linear-gradient(180deg, #000 0%, rgba(0,0,0,0.7) 50%, #000 100%)" }} />
      </div>

      <div className="max-w-[1280px] mx-auto px-6 sm:px-10">
        <div className="text-center max-w-3xl mx-auto">
          <Reveal>
            <p className="text-[11px] tracking-luxe uppercase text-white/45 mb-4">— Video Production</p>
          </Reveal>
          <Reveal delay={120}>
            <h2 className="font-display text-4xl sm:text-5xl md:text-6xl leading-[1.05]">
              <span className="text-chrome">Beyond stills.</span>{" "}
              <span className="italic text-magcyan">In motion.</span>
            </h2>
          </Reveal>
          <Reveal delay={240}>
            <p className="mt-7 text-white/70 leading-relaxed font-body">
              Beyond photography, WelkomBiz Photography also creates premium business,
              lodge, promotional, intro and event videos designed to help brands and
              special occasions stand out.
            </p>
          </Reveal>
        </div>

        <div className="mt-16 grid grid-cols-2 md:grid-cols-3 lg:grid-cols-5 gap-4">
          {VIDEO_SERVICES.map((v, i) => {
            const Icon = Icons[v.icon] || Icons.Film;
            return (
              <Reveal key={v.title} delay={i * 90}>
                <div className="glass chrome-border rounded-md p-6 text-center h-full lift">
                  <div className="w-11 h-11 mx-auto rounded-full flex items-center justify-center mb-4 chrome-border bg-black/40">
                    <Icon className="w-4 h-4 text-white" />
                  </div>
                  <h3 className="font-display text-xl text-chrome">{v.title}</h3>
                </div>
              </Reveal>
            );
          })}
        </div>
      </div>
    </section>
  );
};

export default VideoProduction;
